module.exports = __webpack_public_path__ + "img/kicks20.49899df4.png";